export const translations = {
    en: {
        Dashboard: "Dashboard",
        KnowledgeBase: "Knowledge Base",
        KYCForm: "KYC Form",
        PlatformGrievanceMechanisms: "Platform Grievance Mechanisms",
        TraceabilityGuidefor3TGOperators: "Traceability Guide for 3TG Operators",
        RiskManagementPlan: "Risk Management Plan",
        ShipmentConformanceNotice: "Shipment Conformance Notice",
        SupplierCodeofConduct: "Supplier Code of Conduct",
        OperatorOnboarding: "Operator Onboarding",
        KnowYourCounterpartForm: "Know Your Counterpart Form",
        TraceDueDiligenceProgrammeIntroduction: "Trace Due Diligence Programme Introduction",
        RwandaInternalSupplement: "Rwanda - Internal Supplement",
        Download: "Download"
    },
    fr: {
        Dashboard: "Tableau de bord",
        KnowledgeBase: "Base de connaissances",
        KYCForm: "Formulaire KYC",
        PlatformGrievanceMechanisms: "Mécanismes de réclamation de la plateforme",
        TraceabilityGuidefor3TGOperators: "Guide de traçabilité pour les opérateurs 3TG",
        RiskManagementPlan: "Plan de gestion des risques",
        ShipmentConformanceNotice: "Avis de conformité de l'envoi",
        SupplierCodeofConduct: "Code de conduite des fournisseurs",
        OperatorOnboarding: "Embarquement de l'opérateur",
        KnowYourCounterpartForm: "Formulaire de connaissance des contreparties",
        TraceDueDiligenceProgrammeIntroduction: "Introduction au programme de diligence raisonnable de Trace",
        RwandaInternalSupplement: "Rwanda - Supplément interne",
        Download: "Télécharger"
    }
};